module.exports = __webpack_public_path__ + "img/elagage_3.4383527b.jpg";